import { useEffect } from "react";
import type { LegitimateAny } from "@kivra/sdk/types/util";

export function useOnMount(functionToCallOnMount: () => LegitimateAny): void {
  useEffect(() => {
    const result = functionToCallOnMount();
    if (typeof result === "function") {
      return result;
    }
  }, []);
}
